
import { mixins } from "vue-class-component";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class WindowAlerts extends Vue {
  @Prop(Array) readonly items!: any[];

  dismiss(index: number) {
    this.items.splice(index, 1);
  }

  bgColor(code: number) {
    switch (code) {
      case 1:
        return "bg-green-50";
      case 2:
        return "bg-yellow-50";
      case 3:
        return "bg-red-50";
      default:
        return "bg-blue-50";
    }
  }

  svgColor(code: number) {
    switch (code) {
      case 1:
        return "text-green-500 hover:bg-green-100 focus:bg-green-100";
      case 2:
        return "text-yellow-500 hover:bg-yellow-100 focus:bg-yellow-100";
      case 3:
        return "text-red-500 hover:bg-red-100 focus:bg-red-100";
      default:
        return "text-blue-500 hover:bg-blue-100 focus:bg-blue-100";
    }
  }
}
